






















































import Vue from 'vue';
import {
  HubCard,
  HubHeading,
  HubIcon,
} from './HubComponents';

export default Vue.extend({
  name: 'AppHeader',
  components: {
    HubCard,
    HubHeading,
    HubIcon,
  },
  props: {
    lg: {
      type: Boolean,
      default: false,
    },
    buttons: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    iconSize() {
      const {
        xs, sm, md, lg, xl,
      } = this.$vuetify.breakpoint;
      if (xs) return 'medium';
      if (sm) return 'large';
      if (md) return 'large';
      if (lg) return 'large';
      return 'large'; // Default size
    },
  },
});
